'use client'

import { ShieldOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useTaxRatesList } from '@/lib/api/taxRates'
import { useStoreNavigate } from '@/hooks/use-app-navigate'
import { EditableTaxRatesTable } from './components/editable-tax-rates-table'

import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';

export default withRequiredPermission(TaxRatesPage, PERMISSIONS.STORES_VIEW);

function TaxRatesPage() {
    const { t } = useTranslation(['taxes', 'common'])
    const { id, storeRoutes } = useStoreNavigate()

    const {
        data: taxRatesResponse,
        isLoading,
        error,
    } = useTaxRatesList({ storeId: id })

    const taxRates = taxRatesResponse?.items ?? []

    return (
        <div className="flex flex-col space-y-4 sm:space-y-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
                <div>
                    <h1 className="text-xl font-semibold sm:text-2xl">{t('title')}</h1>
                    <p className="text-muted-foreground text-sm">{t('description')}</p>
                </div>
                <Link to={storeRoutes.TAX_EXEMPTIONS()}>
                    <Button variant="outline" className="w-full sm:w-auto">
                        <ShieldOff className="mr-2 h-4 w-4" />
                        {t('exemptions.title')}
                    </Button>
                </Link>
            </div>

            <Card>
                <CardContent className="pt-6">
                    {isLoading ? (
                        <div className="flex h-24 items-center justify-center text-muted-foreground">
                            {t('common:loading')}
                        </div>
                    ) : (
                        <EditableTaxRatesTable taxRates={taxRates} storeId={id} />
                    )}
                </CardContent>
            </Card>

            {error && (
                <div className="rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
                    {error instanceof Error ? error.message : t('loadError')}
                </div>
            )}
        </div>
    )
}
